import { cn } from "@/lib/utils";

function Spinner({ className, size = "md" }: { className?: string; size?: "sm" | "md" | "lg" }) {
  const sizeClasses = { sm: "size-4", md: "size-5", lg: "size-6" };
  return (
    <div
      className={cn("animate-spin rounded-full border-2 border-current border-t-transparent", sizeClasses[size], className)}
    >
      <span className="sr-only">Loading</span>
    </div>
  );
}

export { Spinner };
